var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMonRemoteDevices01 = function SvgMonRemoteDevices01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mon_remote_devices-01_svg2__a",
    x1: -18.88,
    x2: 161.07,
    y1: 143.67,
    y2: 14.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#mon_remote_devices-01_svg2__a",
    id: "mon_remote_devices-01_svg2__b",
    x1: 21.72,
    x2: 201.67,
    y1: 200.41,
    y2: 71.66
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#mon_remote_devices-01_svg2__a",
    id: "mon_remote_devices-01_svg2__c",
    x1: 48.4,
    x2: 228.35,
    y1: 237.7,
    y2: 108.95
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M76.62 129.85c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13H6.26v-90.4a3.55 3.55 0 0 1 3.55-3.55h160.33a3.55 3.55 0 0 1 3.55 3.55V100c0 1.73 1.4 3.13 3.13 3.13s3.13-1.4 3.13-3.13V33.19c0-5.41-4.4-9.81-9.81-9.81H9.81C4.4 23.38 0 27.78 0 33.19v106.89c0 5.41 4.4 9.81 9.81 9.81h56.58l-2.56 20.46h-3.92c-1.73 0-3.13 1.4-3.13 3.13s1.4 3.13 3.13 3.13h16.7c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13h-6.47l2.56-20.46h3.92c1.73 0 3.13-1.4 3.13-3.13s-1.4-3.13-3.13-3.13H9.81a3.55 3.55 0 0 1-3.55-3.55v-10.23z",
    style: {
      fill: "url(#mon_remote_devices-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.42 83.51H96.66c-5.41 0-9.81 4.4-9.81 9.81v73.49c0 5.41 4.4 9.81 9.81 9.81h46.76c5.41 0 9.81-4.4 9.81-9.81V93.32c0-5.41-4.4-9.81-9.81-9.81m-50.31 19.62h53.86v53.86H93.11zm50.31 67.22H96.66a3.55 3.55 0 0 1-3.55-3.55v-3.55h53.86v3.55a3.55 3.55 0 0 1-3.55 3.55m3.55-73.48H93.11v-3.55a3.55 3.55 0 0 1 3.55-3.55h46.76a3.55 3.55 0 0 1 3.55 3.55z",
    style: {
      fill: "url(#mon_remote_devices-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.19 110.23h-20.04c-5.41 0-9.81 4.4-9.81 9.81v46.76c0 5.41 4.4 9.81 9.81 9.81h20.04c5.41 0 9.81-4.4 9.81-9.81v-46.76c0-5.41-4.4-9.81-9.81-9.81m0 60.12h-20.04a3.55 3.55 0 0 1-3.55-3.55v-3.55h27.14v3.55a3.55 3.55 0 0 1-3.55 3.55m3.55-13.36H166.6v-27.14h27.14zm0-33.4H166.6v-3.55a3.55 3.55 0 0 1 3.55-3.55h20.04a3.55 3.55 0 0 1 3.55 3.55z",
    style: {
      fill: "url(#mon_remote_devices-01_svg2__c)"
    }
  }));
};
export default SvgMonRemoteDevices01;